export default __webpack_public_path__ + "static/media/Untitled-1.8116907a.jpg";